import {
  SELECT_ELEMENT,
  SELECT_PROCESS,
  SELECT_SUBMISSION,
  SHOW_SCROLL_ARROW,
  HIDE_SCROLL_ARROW
} from "./types";

export const selectElement = element => dispatch => {
  dispatch({ type: SHOW_SCROLL_ARROW });
  dispatch({ type: SELECT_ELEMENT, payload: element });
  setTimeout(() => dispatch({ type: HIDE_SCROLL_ARROW }), 1500);
};

export const clearSelectedElement = () => {
  return selectElement(null);
};

export const selectProcess = process => dispatch => {
  dispatch({ type: SELECT_PROCESS, payload: process });
};

export const clearSelectedProcess = () => {
  return selectProcess(null);
};

export const selectSubmission = (submission, type) => dispatch => {
  dispatch({ type: SELECT_SUBMISSION, payload: { submission, type } });
};

export const clearSelectedSubmission = () => {
  return selectSubmission(null, null);
};
